import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(h, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      d: "m10.25 3-.875.9H5v1.8h.875v13.5c0 .47.167.95.497 1.288.33.34.796.512 1.253.512h8.75c.457 0 .923-.172 1.253-.512.33-.339.497-.818.497-1.288V5.7H19V3.9h-4.375L13.75 3zM7.625 5.7h8.75v13.5h-8.75zm1.75 1.8v9.9h1.75V7.5zm3.5 0v9.9h1.75V7.5z"
    }, null, -1)
  ])]);
}
const m = { render: l };
export {
  m as default,
  l as render
};
